import { Component } from '@angular/core';

@Component({
    selector: 'dialog-container',
    template: `
        <ng-content></ng-content>`
})
export class DialogContainerComponent {
}
